import { Injectable } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { Building } from 'src/app/geometrics-form/buildings/state/building.model';
import { GeometricFormType } from 'src/app/geometrics-form/state/geometric-form.type';
import { MapService } from 'src/app/shared/components/map/map.service';
import { buildingBorderToFeature } from '../mappers/geojon-mapper';
import { Plotter } from './plotter';

@Injectable({
  providedIn: 'root'
})
export class BuildingBorderPlotter extends Plotter<Building> {

  type: GeometricFormType = 'mitra-building-border';
  mapper = buildingBorderToFeature;

  constructor(
    protected mapService: MapService
  ) {
    super([]);

    mapService.map$.subscribe(m => this.init(m));
  }

  layer: mapboxgl.Layer = {
    id: this.type,
    type: 'circle',
    source: this.type,
    paint: {
      'circle-color': '#fdca40',
      'circle-opacity': 0.95,
      'circle-radius': [
        'interpolate',
        ['linear'],
        ['zoom'],
        1,
        0.5,
        10,
        0.5,
        15,
        2,
        20,
        7,
        22,
        15
      ],
    }
  };

}
